import { render, staticRenderFns } from "./Diamond.vue?vue&type=template&id=0495cd52&"
import script from "./Diamond.vue?vue&type=script&lang=js&"
export * from "./Diamond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports